<template>
 <div v-bind:class="{ 'reservation-notes-modal': true, show: show }">
    <div class="reservation-notes-modal-container">
      <div class="reservation-notes-modal-content">
        <div class="notes-modal" v-show="show">
          <div class="title">
            <span>Refund Options</span>
          </div>

          <div class="cancellation">
            <span>
              Select refund option:
            </span>
            <div class="optionRefund">
              <label>
              <input type="radio" name="cancelFee" value="0" v-model="cancelFee">
                Refund as Credit
              </label>
            </div>
            <div class="optionRefund">
              <label>
              <input type="radio" name="cancelFee" value="1" v-model="cancelFee">
                Refund Immediately
              </label>
            </div>
          </div>

          <div class="cancel-reason">
            <span>Notes:</span>
            <textarea></textarea>
          </div>

          <div class="controls row">
            <div class="small-6 columns padding-R">
              <a :class="{'button cta warning block small':true, 'disabled':isSubmitting}"
                href="javascript:;" @click="close">{{ $t('rsvpNotes.cancel') }}</a>
            </div>
            <div class="small-6 columns padding-L">
              <a v-bind:class="{ 'button cta success block small': true, disabled: isSubmitting}"
                 href="javascript:;" @click="submit">
                <i v-show="isSubmitting" class="fa fa-spinner fa-spin fa-fw"></i>
                <span v-show="!isSubmitting">{{ $t('rsvpNotes.confirm') }}</span>
              </a>
            </div>
          </div>
        </div>

        <div class="success-modal" v-show="showComplete">
          <i class="fas fa-check-circle fa-fw fa-3x"></i>
          <div class="message">
            Success marked
            <!-- <span v-if="isPackage">package</span> -->
            <span>reservation</span>
            as complete.
          </div>
        </div>

        <!-- <div class="refund-fail" v-show="refundModal.show">
          <i class="fas fa-exclamation-triangle fa-5x" v-if="refundModal.status === 'error'"></i>
          <i class="far fa-thumbs-up fa-5x" v-else></i>
          <div class="message">{{ refundModal.message }}</div>
          <a :class="['button cta block small', refundModal.status === 'error' ? 'warning' : 'success']"
            @click="close">{{ $t('rsvpNotes.close') }}</a>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
import Tribute from 'tributejs'
import moment from 'moment'
import ApiRsvpEdit from '@/modules/api/reservation-details/edit'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'reservation-notes-modal',
  data () {
    return {
      noteError: false,
      isSubmitting: false,
      cancelFee: '0',
      showComplete: false
    }
  },
  computed: {
    show () { return this.$store.state.refundCredit.show },
    notes () { return this.$store.state.refundCredit.notes },
  },
  methods: {
    populate () {
      let self = this
      let value = self.$refs.noteTextArea.innerHTML
      self.noteError = false
      if (value.length > 500) {
        self.$refs.noteTextArea.innerHTML = self.$store.state.reservationNotes.notes
        return
      }
      self.$store.commit('refundCredit/setNotes', value)
    },
    close () {
      if (this.isSubmitting ) { return }
      this.$store.commit('refundCredit/show', false)
    },
    submit () {}
  }
}
</script>

<style lang="scss" scoped>
.reservation-notes-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.reservation-notes-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.reservation-notes-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
}

.notes-modal{

  & .title{
    color: #fff;
    background-color: #0D79F2;
    padding: 10px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .customer-label{
    padding: 15px 15px 5px;
    font-size: 14px;
    color: #333;
  }

  & label{
    display: block;
    font-weight: 700;
    font-size: 14px;
    color: #555;
    margin-bottom: 5px;
  }

  & .cancel-reason {
    margin-top: 15px;
  }

  & .notes, & .cancel-reason{
    text-align: left;
    padding: 15px;
    & textarea, & .textarea{
      resize: none;
      display: block;
      outline: 0;
      appearance: none;
      box-sizing: border-box;
      width: 100%;
      border: 1px solid rgba(0,0,0,0.35);
      height: 100px;
      font-size: 14px;
      padding: 10px;
      line-height: inherit;
      border-radius: 3px;
      overflow: auto;
      transition: all 250ms;

      &.error {
        border-color: #F20D0D;
        border-width: 2px;
        background-color: rgba(242,13,13,0.03);
        border-radius: 0;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
      }
    }

    & span {
      display: block;
      text-align: left;
      font-size: 14px;
      margin-top: 2px;
      font-weight: 700;
      color: #777;
    }
  }

  & .status, & .cancel-reason {
    text-align: left;
    padding: 0 20px 15px;

    & select{
      display: block;
      outline: 0;
      box-sizing: border-box;
      border: 1px solid rgba(0,0,0,0.35);
      font-size: 14px;
      padding: 10px;

      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;
    }
  }

  & .controls{
    padding: 0 15px 15px;

    & .padding-L { padding-left: 7px; }
    & .padding-R { padding-right: 7px; }
  }

  & .error-message{
    background-color: #F20D0D;
    color: #fff;
    font-size: 12px;
    text-align: center;
    font-weight: 700;
    padding: 0 3px;
    height: 0;
    overflow: hidden;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    transition: all 250ms;

    &.show {
      height: 26px;
      padding: 3px 3px;
    }
  }
}

.success-modal {
  padding: 15px 0;

  & i {
    color: #26D97A;
    margin-bottom: 10px;
  }

  & .message { font-weight: 700; color: #555; }
}

.full-refund{
  padding: 10px 20px;
  font-size: 13px;
  background: #f7eeb2;
  border: 1px solid #d0be42;
  border-radius: 4px;
  margin: 10px 10px 0;
  line-height: 140%;

  span{
    display: block;
  }
  label{
    display: inline-block;
    margin: 10px 20px 0;
    cursor: pointer;

    input{
      margin: 0 3px 0 0;
      width: auto;
      display: inline-block;
      vertical-align: -1px;
    }
  }
}

.cancel-fee-loader{
  color: #5da3f0;
  margin-top: 10px;
}
.cancellation-fee{
  padding: 10px 20px;
  font-size: 12.5px;
  background: #f4c6c6;
  border: 1px solid #e75e5e;
  border-radius: 4px;
  margin: 10px 10px 0;
  line-height: 140%;

  span{ display: block; }
  label{
    display: inline-block;
    margin: 10px 20px 0;
    cursor: pointer;

    input{
      margin: 0 3px 0 0;
      width: auto;
      display: inline-block;
      vertical-align: -1px;
    }
  }
}

.partial-refund{
  padding: 10px;
  text-align: left;

  label{ line-height: 1; }
}
.refund-field{
  line-height: 1;
  display: flex;
  position: relative;

  select{
    padding: 5px;
    font-size: 15px;
    height: 40px;
    vertical-align: top;
  }
  .refund-input{
    vertical-align: top;
    width: 0;
    opacity: 0;
    position: relative;
    transition: all .3s ease-in;

    i{
      position: absolute;
      z-index: 2;
      top: 50%;
      transform: translateY(-50%);
      left: 5px;
      color: #ccc;
    }
    input{
      margin: 0;
      height: 40px;
      border-color: #999;
      padding-left: 22px;
      position: relative;
      border-radius: 0 3px 3px 0;
      z-index: 1;

      &.has-error{ border-color: #ff6115; }
    }
  }
  span.has-error{
    position: absolute;
    top: 100%;
    right: 0;
    padding: 4px 5px;
    background: #ff6115;
    color: #fff;
    font-size: 13px;
    line-height: 1;
    transform-origin: top center;
  }
  &.show-input{
    select{
      border-right: none;
      border-radius: 3px 0 0 3px;
    }
    .refund-input{
      width: 120px;
      opacity: 1;
    }
  }
}

.refund-fail{
  padding: 20px;

  i {
    margin-bottom: 10px;
    &.fa-exclamation-triangle{ color: #ffc800; }
    &.fa-thumbs-up{ color: #26d97a; }
  }
  .message{
    font-size: 15px;
    margin-bottom: 20px;
  }
}
.cancel-error {
  background-color: red;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  padding: 5px;
}
.select-error {
  border: 2px solid red !important;
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.cancellation {
  text-align: left;
  padding: 20px;
  padding-bottom: 5px;
  label {
    display: table-cell;
  }
  input {
    width: auto !important;
    display: inline-block;

  }
}
</style>

<style lang="scss">
.notes-custom-label{
  padding: 15px;
  font-size: 14px;

  .text-left{ text-align:left; }
  .price-difference{
    margin-top: 10px;
    span{
      display: inline-block;
      margin: 0 10px;
      font-weight: 600;

      &.lower{ color: #F20D0D; }
      &.higher{ color: #26D97A; }
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
@media only screen and (max-width: 430px) {
  .reservation-notes-modal.show {
    .notes-modal {
      height: 100vh;
      overflow: scroll;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Transactions/RefundCreditModal.vue